import '../nice_select.js'

export default function API_MAPS(allAddress) {
    // Configuration and Constants
    const CONFIG = {
        API_KEY: 'QEYPoO3xSNcfZayZbpLwO9JjJU5_id9rgrmM7QogASw',
        DEFAULT_RAY_KM: 20,
        DEFAULT_ZOOM: 5,
        SEARCH_ZOOM: 8,
        STORE_DETAIL_ZOOM: 17,
        COMPANY_ZOOM: 10,
        SMOOTH_SCROLL_DURATION: 400,
        EARTH_RADIUS_METERS: 6371000,
        DEFAULT_COORDS: {
            lat: -15.793889,
            lng: -47.882778,
            title: "Artesano Móveis"
        },
        CENTRAL_STORE: {
            lat: -29.10275709682426,
            lng: -51.54494217768606,
            title: "Artesano Móveis"
        }
    };

    
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                CONFIG.DEFAULT_COORDS.lat = position.coords.latitude;
                CONFIG.DEFAULT_COORDS.lng = position.coords.longitude;
            },
            (error) => {
                console.warn('Geolocation permission denied or unavailable.', error);
            }
        );
    } else {
        console.warn('Geolocation is not supported by this browser.');
    }

    // State Management
    class MapState {
        constructor() {
            this.isMobile = window.screen.width < 999;
            this.platform = null;
            this.geocoder = null;
            this.map = null;
            this.ui = null;
            this.clusteringLayer = null;
            this.objectLayerCircle = null;
            this.objectProviderCircle = null;
            
            this.hasNearbyStores = false;
            this.nearbyStores = [];
            this.nearbyStoresPerView = [];
            this.allCoords = [];
            this.amountToShow = 50;
            this.saveUserCoords = null;
            this.isUserOrCompany = 'user';
            this.centralStoreData = CONFIG.CENTRAL_STORE;
            this.currentRayKm = CONFIG.DEFAULT_RAY_KM;
        }

        get markerDimensions() {
            return {
                width: this.isMobile ? 30 : 53,
                height: this.isMobile ? 43 : 76,
                companyWidth: this.isMobile ? 35 : 63,
                companyHeight: this.isMobile ? 49 : 83
            };
        }
    }

    const state = new MapState();

    // DOM Elements
    const DOM = {
        get inputAddress() {
            const selector = state.isMobile 
                ? "#search-stores.mobile #address-form"
                : "#search-stores #address-form";
            return document.querySelector(selector);
        },
        modalLoading: document.querySelector('#loading-modal'),
        modalErrorMessage: document.querySelector('#messages-modal'),
        modalMessage: document.querySelector('#messages-modal .description'),
        modalTitle: document.querySelector('#messages-modal .title'),
        btnCloseError: document.querySelectorAll("#messages-modal .close-info-message"),
        markerStores: document.getElementById('pin-markerStores').dataset.image,
        markerUser: document.getElementById('pin-markerUser').dataset.image,
        markerCompany: document.getElementById('pin-markerCompany').dataset.image
    };

    // Utility Functions
    const Utils = {
        toRadians(degrees) {
            return (degrees * Math.PI) / 180;
        },

        smoothScrollTo(endX, endY, duration = CONFIG.SMOOTH_SCROLL_DURATION) {
            const startX = window.scrollX || window.pageXOffset;
            const startY = window.scrollY || window.pageYOffset;
            const distanceX = endX - startX;
            const distanceY = endY - startY;
            const startTime = Date.now();

            const easeInOutQuart = (time, from, distance, duration) => {
                if ((time /= duration / 2) < 1) {
                    return (distance / 2) * time * time * time * time + from;
                }
                return (-distance / 2) * ((time -= 2) * time * time * time - 2) + from;
            };

            const timer = setInterval(() => {
                const time = Date.now() - startTime;
                const newX = easeInOutQuart(time, startX, distanceX, duration);
                const newY = easeInOutQuart(time, startY, distanceY, duration);
                
                if (time >= duration) {
                    clearInterval(timer);
                    window.scroll(endX, endY);
                } else {
                    window.scroll(newX, newY);
                }
            }, 1000 / 60);
        },

        calculateDistance(firstLocation, secondLocation) {
            const startLat = this.toRadians(firstLocation.lat);
            const startLng = this.toRadians(firstLocation.lng);
            const endLat = this.toRadians(secondLocation.lat);
            const endLng = this.toRadians(secondLocation.lng);

            const differenceLat = endLat - startLat;
            const differenceLng = endLng - startLng;

            // Haversine formula
            const a = Math.sin(differenceLat / 2) ** 2 +
                Math.cos(startLat) * Math.cos(endLat) * Math.sin(differenceLng / 2) ** 2;

            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            
            // Distance in kilometers
            return (CONFIG.EARTH_RADIUS_METERS * c) / 1000;
        },

        formatAddress(address) {
            const addressNumbers = address.replace(/[^\d]/g, "");
            const addressClean = address.replace(/[\s]/g, "");
            
            if (addressClean.length < 10 && addressNumbers.length === 8) {
                const part1 = addressNumbers.slice(0, 5);
                const part2 = addressNumbers.slice(5, 8);
                return `${part1}-${part2} BR`;
            }
            return address;
        }
    };

    // Modal Management
    const Modal = {
        showMessage(message, title = 'Ops!') {
            DOM.modalMessage.innerHTML = message;
            DOM.modalTitle.innerHTML = title;
            DOM.modalErrorMessage.classList.add('open-modal');
        },

        showLoading() {
            DOM.modalLoading.style.display = 'flex';
        },

        hideLoading() {
            DOM.modalLoading.style.display = 'none';
        }
    };

    // Geocoding Service
    const GeocodingService = {
        async findCoordinates(address) {
            const formattedAddress = Utils.formatAddress(address);
            
            return new Promise((resolve, reject) => {
                const geocodingParams = {
                    searchText: formattedAddress,
                    q: formattedAddress,
                };

                const onResult = (result) => {
                    try {
                        const locations = result.items[0].position;
                        resolve({
                            lat: locations.lat,
                            lng: locations.lng
                        });
                    } catch (error) {
                        resolve(undefined);
                    }
                };

                const onError = () => {
                    reject(new Error('Geocoding failed'));
                };

                state.geocoder = state.platform.getSearchService();
                state.geocoder.geocode(geocodingParams, onResult, onError);
            });
        }
    };

    // Marker Creation
    const MarkerFactory = {
        createClusterTemplate() {
            return `<svg id="er4mKozcWDB1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 53.144 75.735" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><g transform="translate(-2685.73-1771.34)"><path d="M2711.66,1771.342c13.811,0,24.937,9.565,26.932,22.639.632691,5.018099.010081,10.114776-1.812,14.833-2.497005,6.775308-5.807215,13.222461-9.858,19.2-4.281907,6.545842-9.006604,12.791088-14.141,18.692-.308.356-.474.581-.91.072-7.705181-8.732827-14.395563-18.310979-19.943-28.551-2.597188-4.752243-4.505614-9.849571-5.668-15.139-2.845941-14.243534,6.279651-28.130847,20.483-31.171c1.614677-.361354,3.262515-.554054,4.917-.575Z" fill="#D9BF80"/></g><ellipse rx="19.537263" ry="19.537263" transform="translate(26.572 27.682849)" fill="#D9BF80" stroke-width="0"/><text dx="0" dy="0" font-family="'Roboto', Arial, Helvetica, sans-serif" font-size="{fontSize}" font-weight="700" style='transform: {positionTransform};' fill="#562E27" stroke-width="0"><tspan y="0" font-weight="700" stroke-width="0">{weight}</tspan></text></svg>`;
        },

        getClusterPresentation(cluster) {
            const weight = cluster.getWeight();
            let positionTransform, fontSize;

            if (weight < 10) {
                positionTransform = 'translate(20px, 36px)';
                fontSize = '25px';
            } else if (weight < 100) {
                positionTransform = 'translate(13px, 36px)';
                fontSize = '25px';
            } else {
                positionTransform = 'translate(12px, 34px)';
                fontSize = '18px';
            }

            const svgString = this.createClusterTemplate()
                .replace(/\{weight\}/g, weight)
                .replace(/\{positionTransform\}/g, positionTransform)
                .replace(/\{fontSize\}/g, fontSize);

            const { width, height } = state.markerDimensions;
            const clusterIcon = new H.map.Icon(svgString, {
                size: { w: width, h: height },
                anchor: { x: 30, y: 30 }
            });

            return new H.map.Marker(cluster.getPosition(), {
                icon: clusterIcon,
                min: cluster.getMinZoom(),
                max: cluster.getMaxZoom()
            });
        },

        getNoisePresentation(noisePoint) {
            const data = noisePoint.getData();
            const { width, height } = state.markerDimensions;

            const noiseMarker = new H.map.Marker(noisePoint.getPosition(), {
                min: noisePoint.getMinZoom(),
                icon: new H.map.Icon(DOM.markerStores, {
                    size: { w: width, h: height },
                }),
            });

            const textInMarker = this.createInfoBubbleContent(data);
            noiseMarker.setData(textInMarker);

            return noiseMarker;
        },

        createInfoBubbleContent(data) {
            const fields = ['title', 'address', 'phones', 'emails'];
            return fields
                .filter(field => data[field])
                .map(field => {
                    const content = data[field];
                    const style = field === 'title' ? `<b style='text-transform: uppercase;'>${content}</b>` : content;
                    return `<p>${style}</p>`;
                })
                .join('\n');
        },

        createUserMarker(lat, lng) {
            const group = new H.map.Group();
            const coords = { lat, lng };
            
            const icon = new H.map.Icon(DOM.markerUser, {
                size: { w: 63, h: 63 }
            });
            
            const marker = new H.map.Marker(coords, { icon });
            const circle = this.createCircle(lat, lng);
            
            group.addObject(circle);
            group.addObject(marker);
            state.map.addObject(group);
        },

        createCompanyMarker(lat = state.centralStoreData.lat, lng = state.centralStoreData.lng) {
            MapManager.clearMarkers();

            const circle = this.createCircle(lat, lng);
            this.addCircleLayer(circle);

            const group = new H.map.Group();
            const coords = { lat, lng };
            const { companyWidth, companyHeight } = state.markerDimensions;
            
            const icon = new H.map.Icon(DOM.markerCompany, {
                size: { w: companyWidth, h: companyHeight }
            });
            
            const marker = new H.map.Marker(coords, { icon });

            group.addEventListener('tap', (evt) => {
                const bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
                    content: evt.target.getData()
                });
                state.ui.addBubble(bubble);
            }, false);

            const textInMarker = this.createInfoBubbleContent(state.centralStoreData);
            marker.setData(textInMarker);
            
            MapManager.setCenter(state.centralStoreData.lat, state.centralStoreData.lng, CONFIG.COMPANY_ZOOM);
            
            group.addObject(marker);
            state.map.addObject(group);
            state.nearbyStores.push(state.centralStoreData);
        },

        createCircle(lat, lng) {
            return new H.map.Circle(
                { lat, lng },
                state.currentRayKm * 1000,
                {
                    style: {
                        strokeColor: '#D9BF80',
                        lineWidth: 2,
                        fillColor: 'rgba(85, 46, 0, 0.1)',
                        zIndex: 0,
                    }
                }
            );
        },

        addCircleLayer(circle) {
            state.objectProviderCircle = new H.map.provider.LocalObjectProvider();
            state.objectLayerCircle = new H.map.layer.ObjectLayer(state.objectProviderCircle);
            state.objectProviderCircle.getRootGroup().addObject(circle);
            state.map.addLayer(state.objectLayerCircle);
        }
    };

    // Map Management
    const MapManager = {
        async initialize(lat = CONFIG.DEFAULT_COORDS.lat, lng = CONFIG.DEFAULT_COORDS.lng, isUserLocation = false, zoom = CONFIG.DEFAULT_ZOOM) {
            state.platform = new H.service.Platform({
                'apikey': CONFIG.API_KEY
            });

            const defaultLayers = state.platform.createDefaultLayers();

            state.map = new H.Map(
                document.getElementById('map--stores'),
                defaultLayers.vector.normal.map,
                {
                    zoom,
                    center: { lat, lng },
                    pixelRatio: window.devicePixelRatio || 1
                }
            );

            const mapEvents = new H.mapevents.MapEvents(state.map);
            const behavior = new H.mapevents.Behavior(mapEvents);
            state.ui = H.ui.UI.createDefault(state.map, defaultLayers);

            window.addEventListener('resize', () => state.map.getViewPort().resize());

            if (isUserLocation) {
                const userCoords = { lat, lng };
                StoreManager.findNearbyStores(userCoords);
                
                if (state.hasNearbyStores) {
                    StoreManager.setStoresPerView(state.saveUserCoords);
                } else {
                    StoreManager.showCentralStore();
                }
            } else {
                StoreManager.showCentralStore();
            }
        },

        clearMarkers() {
            if (state.objectLayerCircle) {
                state.map.removeLayer(state.objectLayerCircle);
            }
            if (state.clusteringLayer) {
                state.map.removeLayer(state.clusteringLayer);
            }
            state.map.removeObjects(state.map.getObjects());
        },

        setCenter(lat, lng, zoom) {
            try {
                state.map.setCenter({ lat, lng });
                state.map.setZoom(zoom);
            } catch (error) {
                Modal.showMessage(
                    'Não encontramos o endereço pesquisado, exibiremos a central Artesano e encantadoras lojas nas proximidades.',
                    'Ops!'
                );
                setTimeout(() => {
                    LocationService.getCurrentLocation();
                }, 2000);
            }
        },

        startClustering() {
            const dataPoints = state.nearbyStoresPerView
                .filter(item => item.lat && item.lng)
                // .filter((store, index, self) =>
                //     index === self.findIndex((s) => s.id === store.id)
                // )
                .map(item => new H.clustering.DataPoint(item.lat, item.lng, null, item));

            const clusteredDataProvider = new H.clustering.Provider(dataPoints, {
                clusteringOptions: {
                    eps: 32,
                    minWeight: 2,
                },
                theme: {
                    getClusterPresentation: MarkerFactory.getClusterPresentation.bind(MarkerFactory),
                    getNoisePresentation: MarkerFactory.getNoisePresentation.bind(MarkerFactory)
                }
            });

            clusteredDataProvider.addEventListener('tap', this.onMarkerClick);
            state.clusteringLayer = new H.map.layer.ObjectLayer(clusteredDataProvider);
            state.map.getLayers().add(state.clusteringLayer);
        },

        onMarkerClick(e) {
            const position = e.target.getGeometry();
            const data = e.target.getData();

            if (data) {
                const bubble = new H.ui.InfoBubble(position, { content: data });
                state.ui.addBubble(bubble);
                state.map.setCenter(position, true);
            }
        },

        zoomToStore(id) {
            if (state.isMobile) {
                Utils.smoothScrollTo(0, 0, 300);
            }
            
            const store = allAddress.find(service => service.id == id);
            if (store) {
                this.setCenter(store.lat, store.lng, CONFIG.STORE_DETAIL_ZOOM);
            }
        }
    };

    // Store Management
    const StoreManager = {
        separateStores() {
            allAddress.forEach(store => {
                if (store.is_central === 1) {
                    state.centralStoreData = store;
                } else {
                    state.allCoords.push(store);
                }
            });

            if (!state.centralStoreData) {
                state.centralStoreData = allAddress[0] || CONFIG.CENTRAL_STORE;
            }
        },

        findNearbyStores(userCoords) {
            Modal.showLoading();
            state.hasNearbyStores = false;
            state.nearbyStores = [];
            state.currentRayKm = CONFIG.DEFAULT_RAY_KM;

            state.allCoords.forEach(store => {
                const storeCoords = { lat: store.lat, lng: store.lng };
                const distance = Utils.calculateDistance(userCoords, storeCoords);

                if (distance < state.currentRayKm) {
                    state.nearbyStores.push({ ...store, distance });
                    state.hasNearbyStores = true;
                }
            });

            // Se não encontrou nenhuma loja, multiplica o raio por 2, 3, 4 e 5 e tenta novamente
            let found = state.hasNearbyStores;
            let multiplier = 2;
            while (!found && multiplier <= 5) {
                state.currentRayKm = CONFIG.DEFAULT_RAY_KM * multiplier;
                state.allCoords.forEach(store => {
                    const storeCoords = { lat: store.lat, lng: store.lng };
                    const distance = Utils.calculateDistance(userCoords, storeCoords);

                    if (distance < state.currentRayKm) {
                        state.nearbyStores.push({ ...store, distance });
                        found = true;
                        state.hasNearbyStores = true;
                    }
                });
                multiplier++;
            }
            
            Modal.hideLoading();
        },

        setStoresPerView(userCoords) {
            state.saveUserCoords = userCoords;
            
            state.nearbyStores.sort((a, b) => a.distance - b.distance);
            state.nearbyStoresPerView = state.nearbyStores.slice(0, state.amountToShow);

            MapManager.clearMarkers();
            MapManager.setCenter(userCoords.lat, userCoords.lng, CONFIG.SEARCH_ZOOM);
            
            if (state.isUserOrCompany === 'user') {
                MarkerFactory.createUserMarker(userCoords.lat, userCoords.lng);
            } else {
                MarkerFactory.createCompanyMarker();
            }
            
            MapManager.startClustering();
            this.loadStoreCards();
        },

        showCentralStore() {
            Modal.showMessage(
                'Não encontramos lojas próximas a você, exibiremos a central Artesano e encantadoras lojas nas proximidades.',
                'Ops!'
            );
            state.isUserOrCompany = 'company';
            this.findNearbyStores(state.centralStoreData);
            this.setStoresPerView(state.centralStoreData);
        },

        loadStoreCards() {
            // Filtra os stores para que não tenha títulos repetidos,
            // mas garante que a store selecionada esteja presente no cluster de markers
            const selectedStoreTitle = DOM.inputAddress.value.trim().toLowerCase();
            let filteredStores = state.nearbyStoresPerView.filter((store, index, self) =>
                index === self.findIndex((s) => s.title && store.title && s.title.toLowerCase() === store.title.toLowerCase())
            );

            // Garante que a store selecionada (pelo título) esteja presente
            if (selectedStoreTitle) {
                const selectedStore = state.nearbyStoresPerView.find(store =>
                    store.title && store.title.toLowerCase() === selectedStoreTitle
                );
                if (selectedStore && !filteredStores.some(store =>
                    store.title && store.title.toLowerCase() === selectedStoreTitle
                )) {
                    filteredStores.unshift(selectedStore);
                }
            }

            state.nearbyStoresPerView = filteredStores;

            const dataForm = 'stores=' + JSON.stringify(state.nearbyStoresPerView).replace(/&/g, "EEE") + '&lat=' + state.saveUserCoords.lat + '&lng=' + state.saveUserCoords.lng + '&address=' + encodeURIComponent(DOM.inputAddress.value.trim());
            
            $.ajax({
                type: "post",
                url: $("#page-maps-stores").attr('filterRoute'),
                data: dataForm,
                dataType: "html",
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                },
                success: (html) => {
                    Modal.hideLoading();
                    $("#result--stores").html(html);
                    this.bindStoreCardEvents();
                }
            });
        },

        bindStoreCardEvents() {
            document.querySelectorAll(".search--ginle--store").forEach(storeElement => {
                storeElement.addEventListener("click", () => {
                    const storeId = storeElement.getAttribute("storeId");
                    MapManager.zoomToStore(storeId);
                });
            });
        }
    };

    // Location Service
    const LocationService = {
        getCurrentLocation() {
            Modal.showLoading();
            navigator.geolocation.getCurrentPosition(
                this.onLocationSuccess.bind(this),
                this.onLocationError.bind(this)
            );
        },

        onLocationSuccess(position) {
            Modal.showLoading();
            StoreManager.separateStores();
            
            try {
                state.saveUserCoords = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                MapManager.initialize(
                    position.coords.latitude,
                    position.coords.longitude,
                    true
                );
            } catch (error) {
                this.onLocationError();
            }
        },

        onLocationError() {
            MapManager.initialize();
        }
    };

    // Event Handlers
    const EventHandlers = {
        initializeNiceSelect() {
            $(document).ready(() => {
                $('#amount-stores').niceSelect();
            });

            $(document).on("click", ".nice-select .option:not(.disabled)", (e) => {
                const value = $(e.target).data("value");
                state.amountToShow = value;
                StoreManager.setStoresPerView(state.saveUserCoords);
            });
        },

        bindModalEvents() {
            DOM.btnCloseError.forEach(btn => {
                btn.addEventListener("click", () => {
                    DOM.modalErrorMessage.classList.remove('open-modal');
                });
            });
        },

        bindSearchForm() {
            $(document).on('submit', "#search-stores", async (e) => {
                e.preventDefault();
                const address = DOM.inputAddress.value.trim();

                if (!address) {
                    Modal.showMessage('Por favor, informe uma localização!');
                    return;
                }

                try {
                    const userCoords = await GeocodingService.findCoordinates(address);
                    
                    if (userCoords) {
                        MapManager.clearMarkers();
                        StoreManager.findNearbyStores(userCoords);
                        
                        if (state.hasNearbyStores) {
                            state.isUserOrCompany = 'user';
                            StoreManager.setStoresPerView(userCoords);
                        } else {
                            setTimeout(() => StoreManager.showCentralStore(), 1000);
                        }
                    } else {
                        setTimeout(() => StoreManager.showCentralStore(), 1000);
                    }
                } catch (error) {
                    setTimeout(() => StoreManager.showCentralStore(), 1000);
                }
            });
        }
    };

    // Initialize Application
    function init() {
        EventHandlers.initializeNiceSelect();
        EventHandlers.bindModalEvents();
        EventHandlers.bindSearchForm();
        
        $(document).ready(() => {
            LocationService.getCurrentLocation();
        });
    }

    // Start the application
    init();
}